import defaults from '../../translations/en.json';

export const requiredFields = ['incidenttype', 'incidentdatetime_utc'];

export const postSuccess: mumms.ErrorInfo = {
  text: defaults.apiPostSuccess,
  severity: 'success',
};

export const postFailure: mumms.ErrorInfo = {
  text: defaults.apiPostFailure,
  severity: 'error',
};

export const SELECTING = 'SELECTING';
export const TYPING = 'TYPING';
